<template>
    <modal :title="title" :show.sync="show" :close-show="true" class="ensure">
        <div slot="content">
            <p>{{message}}</p>
        </div>
        <div class="footer" slot="footer">
            <a href="javscript:void(0)" class="btn make-sure" @click.prevent="sure(true)">离开并存草稿</a>
            <a href="javscript:void(0)" class="btn gray" @click.prevent="sure(false)">离开不存草稿</a>
            <a href="javscript:void(0)" class="btn cancel" @click.prevent="cancel">取消</a>
        </div>
    </modal>
</template>

<script type="text/javascript">
export default {
    name: 'ensure',
    props: {
        // title: {
        //     type: String,
        //     default: '信息'
        // },
        // message: {
        //     type: String,
        //     default: '信息信息信息信息'
        // },
        // show: {
        //     type: Boolean,
        //     default: false
        // },
        // closeShow: {
        //     type: Boolean,
        //     default: true
        // },
        // onSure: {
        //     type: Function
        // },
        // onCancel: {
        //     type: Function
        // }
    },
    data(){
        return{
            show: true,
            closeShow: true
        }
    },
    methods: {
        close() {
            this.show = false
            this.$emit('update:show', false)
        },
        cancel() {
            if (this.onCancel) this.onCancel()
            this.close()
        },
        sure(saveDraft) {
            if (this.onSure) {
                this.onSure(saveDraft)
                this.close()
            }
        }
    }
}
</script>

<style lang="scss">
.modal.ensure {
    .btn {
        box-sizing: border-box;
        line-height: 30px;
        border: 1px solid transparent;
    }
    .footer {
        text-align: center;
    }
    .content {
        min-height: 92px;
        padding-top: 40px;
    }
    .checkbox {
        margin-bottom: 40px;
    }
    .cancel {
        margin-right: 0;
        border: 1px solid #b8b8b8;
    }
    .gray {
        background-color: #f3f3f3;
        color: #434354;
        border: 1px solid #b8b8b8;
        &:hover {
            background-color: #e9e9e9;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/ensure.vue